import { render, staticRenderFns } from "./VendorTable.vue?vue&type=template&id=17e393c2"
import script from "./VendorTable.vue?vue&type=script&lang=ts"
export * from "./VendorTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports